import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import LoginModal from './LoginModal';
import CartModal from './CartModal';
import { useUser } from '../context/UserContext';
import { globals } from "../globals";
import { useSettings } from '../context/SettingsContext';

// Funzione per ottenere le iniziali da nome e cognome
const getInitials = (name, surname) => {
  const n = name?.charAt(0).toUpperCase() || '';
  const s = surname?.charAt(0).toUpperCase() || '';
  return n + s;
};

function Navbar() {
  const { settings } = useSettings();
  const [click, setClick] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const { user, setUser, logout } = useUser();   // una sola chiamata, con tutto
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const closeLateralMenu = () => setClick(false);

  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
  };

  useEffect(() => {
    // Gli ordini servono solo all'amministratore: per gli altri nessuna chiamata
    if (user?.role !== 'administrator') {
      setPendingOrdersCount(0);
      return;
    }

    const fetchPendingOrders = () => {
      fetch(`${globals.homepageUrl}/php/get-orders.php`)
        .then((res) => res.json())
        .then((data) => {
          if (!Array.isArray(data)) return;
          const pending = data.filter(o => o.stato !== 'completato').length;
          setPendingOrdersCount(pending);
        })
        .catch(() => {});
    };

    fetchPendingOrders(); // iniziale

    window.addEventListener('ordersUpdated', fetchPendingOrders);
    return () => window.removeEventListener('ordersUpdated', fetchPendingOrders);
  }, [user?.role]);
  useEffect(() => {
    const updateCartCount = () => {
      const cartItems = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartCount(cartItems.length);
    };

    // Inizializza
    updateCartCount();

    // Ascolta gli aggiornamenti
    const listener = () => updateCartCount();
    window.addEventListener('cartUpdated', listener);

    return () => window.removeEventListener('cartUpdated', listener);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeLateralMenu}>
            {isMobile ? (
              <>
                <img src="/logo-mobile.png" alt="" style={{ height: ''}} />
                {/* RM<span className='navbar-logo-fotoservices'>foto</span> */}
              </>
            ) : (
              <>
                <img src="/logo.png" alt="" style={{ height: ''}} />
              </>
            )}
          </Link>

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            <li className='nav-item'>
              <Link to='/search' className='nav-links' onClick={closeLateralMenu} title="Ricerca">
                <i className="fas fa-search" style={{ fontSize: '1.6rem' }}></i>
              </Link>
            </li>

            {/* Se è un admin, mostra upload, ingest, user manager */}
            {user?.role === 'administrator' && (
              <>
                <li className='nav-item' style={{ position: 'relative' }}>
                  <Link to='/adminorders' className='nav-links' onClick={closeLateralMenu} title="Admin orders">
                    <i className="fas fa-box" ></i>

                    {pendingOrdersCount > 0 && (
                      <span style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "12px"
                      }}>
                        {pendingOrdersCount}
                      </span>
                    )}
                  </Link>
                </li>

              </>
            )}

            {/* Mobile SignUp */}
            {/*             <li>
              <Link to='/sign-up' className='nav-links-mobile' onClick={closeLateralMenu}>Sign Up</Link>
            </li> */}
          </ul>
          {/* AREA DESTRA: login o utente */}
          <div className="nav-right">

            {/* BOTTONE CARRELLO */}

            <div style={{ display: "flex", alignContent: 'center' }}>

              {settings.enableEcommerce && (
                <button
                  className='nav-links-right'
                  onClick={() => setCartOpen(true)}
                  title="Carrello"
                  style={{
                    background: "none",
                    marginRight: "5px",
                    border: "none",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <i className="fa-solid fa-cart-shopping" ></i>

                  {/* BADGE CARRELLO */}
                  {cartCount > 0 && (
                    <span style={{
                      position: "absolute",
                      top: "0px",
                      right: "3px",
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      fontSize: "12px"
                    }}>
                      {cartCount}
                    </span>
                  )}
                </button>
              )}

              <Link to='/contact' className='nav-links-right' onClick={closeLateralMenu} title="Contatti">
                <i className="fas fa-envelope " ></i>
              </Link>

              {user ? (
                <div className="user-dropdown">
                  <div
                    className="initials-circle"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    {getInitials(user.name, user.surname)}
                  </div>

                  {dropdownOpen && (
                    <div className="dropdown-menu">
                      {/* Profilo sempre visibile */}
                      <Link to='/profile' className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                        <i className="fas fa-user" style={{ marginRight: "8px" }} ></i>
                        <span> Profilo</span>
                      </Link>

                      {/* Tutte le altre voci solo se admin */}
                      {user?.role === 'administrator' && (
                        <>
                          <Link to='/ingest' className='dropdown-item' onClick={() => setDropdownOpen(false)}>
                            <i className="fas fa-file-import" style={{ marginRight: "8px" }} ></i>
                            <span> Ingest</span>
                          </Link>
                          <Link to='/uploadimages' className='dropdown-item' onClick={() => setDropdownOpen(false)}>
                            <i className="fas fa-upload" style={{ marginRight: "8px" }} ></i>
                            <span> Upload</span>
                          </Link>
                          <Link to='/usermanager' className='dropdown-item' onClick={() => setDropdownOpen(false)} title="User Manager">
                            <i className="fas fa-users-cog" style={{ marginRight: "8px" }} ></i>
                            <span> Users</span>
                          </Link>
                          <Link to='/collectionseditor' className='dropdown-item' onClick={() => setDropdownOpen(false)}>
                            <i className="fas fa-search" style={{ marginRight: "8px" }} ></i>
                            <span> Collections editor</span>
                          </Link>

                          <Link to='/savedsearcheseditor' className='dropdown-item' onClick={() => setDropdownOpen(false)}>
                            <i className="fas fa-search" style={{ marginRight: "8px" }} ></i>
                            <span> Searches editor</span>
                          </Link>
                          <Link 
                            to='/slidereditor' 
                            className='dropdown-item' 
                            onClick={() => setDropdownOpen(false)}
                          >
                            <i className="fas fa-images" style={{ marginRight: "8px" }}></i>
                            <span> Slider editor</span>
                          </Link>
                          <Link to='/settings' className='dropdown-item' onClick={() => setDropdownOpen(false)}>
                            <i className="fas fa-gear" style={{ marginRight: "8px" }} ></i>
                            <span> Settings</span>
                          </Link>
                        </>
                      )}

                      <div className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                // Se non è loggato: cart + login icon
                <button className="login-icon-btn" onClick={() => setLoginOpen(true)}>
                  <i className="fas fa-bars" style={{ fontSize: '1.8rem', color: ' #3f3f3f' }}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Modali */}
      {loginOpen && <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />}
      {cartOpen && <CartModal onClose={() => setCartOpen(false)} />}
    </>
  );
}

export default Navbar;
